

export default function iterateByDay(range:MomentRange, callback:any) {

    const arrayDays = Array.from(range.by('days'))

    _.map(arrayDays, (momentDay:Moment)=>{
        callback(momentDay)
    })

}
